export const CREATE_STRIPECUSTOMER_STARTED = "CREATE_STRIPECUSTOMER_STARTED";
export const CREATE_STRIPECUSTOMER_SUCESS = "CREATE_STRIPECUSTOMER_SUCESS";
export const CREATE_STRIPECUSTOMER_FAILED = "CREATE_STRIPECUSTOMER_FAILED";

export const CREATE_FREQUENCY_STARTED = "CREATE_FREQUENCY_STARTED";
export const CREATE_FREQUENCY_SUCESS = "CREATE_FREQUENCY_SUCESS";
export const CREATE_FREQUENCY_FAILED = "CREATE_FREQUENCY_FAILED";

export const GETALL_FREQUENCY_STARTED = "GETALL_FREQUENCY_STARTED";
export const GETALL_FREQUENCY_SUCESS = "GETALL_FREQUENCY_SUCESS";
export const GETALL_FREQUENCY_FAILED = "GETALL_FREQUENCY_FAILED";

export const CREATE_SUBCRIPTION_STARTED = "CREATE_SUBCRIPTION_STARTED";
export const CREATE_SUBCRIPTION_SUCESS = "CREATE_SUBCRIPTION_SUCESS";
export const CREATE_SUBCRIPTION_FAILED = "CREATE_SUBCRIPTION_FAILED";

export const GETALL_SUBCRIPTION_STARTED = "GETALL_SUBCRIPTION_STARTED";
export const GETALL_SUBCRIPTION_SUCESS = "GETALL_SUBCRIPTION_SUCESS";
export const GETALL_SUBCRIPTION_FAILED = "GETALL_SUBCRIPTION_FAILED";

export const CREATE_COMPANY_DISCOUNT_STARTED = "CREATE_COMPANY_DISCOUNT_STARTED";
export const CREATE_COMPANY_DISCOUNT_SUCESS = "CREATE_COMPANY_DISCOUNT_SUCESS";
export const CREATE_COMPANY_DISCOUNT_FAILED = "CREATE_COMPANY_DISCOUNT_FAILED";

export interface IStripePayment {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    MODEMInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    permission_id: number;
    isLoading: boolean;
    error: string;
}

export const createStripeCustomer = (emailId: any) => {
 
    return {
        type: CREATE_STRIPECUSTOMER_STARTED,
        payload: 'status',
        input: emailId
    };
};

export const createFrequency = (frequnceyInput: any) => {
 
    return {
        type: CREATE_FREQUENCY_STARTED,
        payload: 'status',
        input: frequnceyInput
    };
};

export const getAllFrequencyDetails = (id) => {
 
    return {
        type: GETALL_FREQUENCY_STARTED ,
        payload: 'Value',
        input:id 
    };
};


export const saveSubscription = (frequnceyInput: any) => {
 
    return {
        type: CREATE_SUBCRIPTION_STARTED,
        payload: 'status',
        input: frequnceyInput
    };
};

export const getSubscriptionList = (id) => {
 
    return {
        type: GETALL_SUBCRIPTION_STARTED ,
        payload: 'Value',
        input:id 
    };
};


export const createCompanyDiscount = (companyDiscountInput: any) => {

    return {
        type: CREATE_COMPANY_DISCOUNT_STARTED,
        payload: 'status',
        input: companyDiscountInput,
        inputparam:companyDiscountInput.companyCode
    };
};